import { PostApiSpoCustomZonesBody, SpoCustomZonesResponse } from '@spo/types';
import { apiBff } from '.';

export const getCustomZonesByIds = async (
  postApiSpoCustomZonesBody: PostApiSpoCustomZonesBody,
): Promise<SpoCustomZonesResponse> => {
  return apiBff.callBFF('POST', 'spo/custom_zones', postApiSpoCustomZonesBody);
};
